/**
 *@copyright : ToXSL Technologies Pvt. Ltd. < www.toxsl.com >
@author : Shiv Charan Panjeta < shiv@toxsl.com >
All Rights Reserved.
Proprietary and confidential : All information contained herein is, and remains
the property of ToXSL Technologies Pvt. Ltd. and its partners.
Unauthorized copying of this file, via any medium is strictly prohibited. */

import { useState, useRef } from "react";
import { Card, CardBody, Col, Container, Modal, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import { LENDER, RENTER } from "../../globals/constants";
import LenderHeader from "../../Commons/Headers/LenderHeader";
import RenterHeader from "../../Commons/Headers/RenterHeader";
import Header from "../../Commons/Headers/Header";
import useRole from "../../hooks/useRole";

export const About = () => {
  const role = useRole();
  const [nav1, setNav1] = useState();
  const [nav2, setNav2] = useState();
  const slider1 = useRef();
  const slider2 = useRef();
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const ArrowLeft = (props) => (
    <a {...props} className={"prev"}>
      <svg
        width="30"
        height="30"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="15" cy="15" r="14.5" stroke="#E0E0E0" />
        <path
          d="M12.708 9.5L18.208 15L12.708 20.5"
          stroke="#263238"
          strokeWidth="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </a>
  );

  const ArrowRight = (props) => (
    <a {...props} className={"next"}>
      <svg
        width="30"
        height="30"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="15" cy="15" r="14.5" stroke="#E0E0E0" />
        <path
          d="M17.292 20.5L11.792 15L17.292 9.5"
          stroke="#263238"
          strokeWidth="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </a>
  );
  const ArrowLeft1 = (props) => (
    <a {...props} className={"prev"}>
      <svg
        width="30"
        height="30"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="15" cy="15" r="14.5" stroke="#E0E0E0" />
        <path
          d="M12.708 9.5L18.208 15L12.708 20.5"
          stroke="#263238"
          strokeWidth="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </a>
  );

  const ArrowRight1 = (props) => (
    <a {...props} className={"next"}>
      <svg
        width="30"
        height="30"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="15" cy="15" r="14.5" stroke="#E0E0E0" />
        <path
          d="M17.292 20.5L11.792 15L17.292 9.5"
          stroke="#263238"
          strokeWidth="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </a>
  );

  var testimonialSlider = {
    dots: false,
    infinite: true,
    margin: 20,
    speed: 500,
    slidesToScroll: 1,
    slidesToShow: 2,
    centerMode: false,
    autoplay: true,
    autoplaySpeed: 2000,
    prevArrow: <ArrowLeft />,
    nextArrow: <ArrowRight />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  var listingSlider = {
    dots: false,
    infinite: true,
    margin: 20,
    speed: 500,
    slidesToScroll: 1,
    slidesToShow: 2,
    centerMode: false,
    autoplay: true,
    autoplaySpeed: 2000,
    prevArrow: <ArrowLeft1 />,
    nextArrow: <ArrowRight1 />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <>
      {role == LENDER ? (
        <LenderHeader />
      ) : role == RENTER ? (
        <RenterHeader />
      ) : (
        <Header />
      )}
      <div className="pt-5 pb-5">
        <Container>
          <Row>
            <Col md={3} lg={4}>
              <Card className="userdata">
                <CardBody>
                  <div className="d-flex align-items-center justify-content-between">
                    <div className="w-100 text-center">
                      <span className="user-imgmain mx-auto">
                        <img
                          alt="..."
                          className="avatar"
                          src={require("../../assets/images/DummyImg.png")}
                        />
                      </span>
                      <h4 className="mt-3">Jon Smith</h4>
                    </div>
                    <div>
                      <div className="text-center px-4">
                        <h5>120</h5>
                        <p>Reviews</p>
                      </div>
                      <hr />
                      <div className="text-center px-4">
                        <h5>
                          4.79{" "}
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="22"
                            height="25"
                            viewBox="0 0 22 25"
                            fill="none"
                          >
                            <path
                              d="M13.2233 7.77336L12.0463 3.65836C11.7174 2.50711 10.2841 2.50711 9.95407 3.65836M13.2233 7.77336L9.95517 3.65961L9.95407 3.65836M13.2233 7.77336C13.2952 8.02397 13.435 8.24233 13.6226 8.39724M13.2233 7.77336L13.6226 8.39724M9.95407 3.65836L9.95597 3.6589L10.4347 3.79613C10.4398 3.77852 10.4451 3.76146 10.4508 3.74492M9.95407 3.65836L10.3293 3.32794L10.3304 3.32919L10.5111 3.53433L10.4508 3.74492M10.4508 3.74492C10.5651 3.41253 10.8034 3.29492 11.0006 3.29492C11.2074 3.29492 11.4594 3.42437 11.5655 3.79571L11.5655 3.79586L12.7425 7.91086L12.7427 7.91126C12.8403 8.25165 13.0331 8.559 13.3044 8.78286C13.5768 9.00769 13.9139 9.13556 14.2678 9.13586H14.2683H18.0765C18.3267 9.13586 18.5489 9.31214 18.6418 9.63725C18.7346 9.96221 18.653 10.3076 18.4046 10.5131L15.3252 13.0551C15.3251 13.0551 15.3251 13.0552 15.325 13.0552C15.325 13.0553 15.325 13.0553 15.325 13.0553C15.0533 13.2793 14.8602 13.5871 14.7626 13.928C14.6649 14.2689 14.6647 14.6346 14.7621 14.9756L14.7621 14.9759L15.9391 19.0909L15.9392 19.0911C16.0484 19.472 15.9084 19.7951 15.7021 19.9654C15.507 20.1265 15.2689 20.1507 15.0441 19.9652L11.9642 17.4228L11.9641 17.4227C11.6914 17.1977 11.3539 17.0699 10.9996 17.0699C10.6453 17.0699 10.3079 17.1977 10.0352 17.4227L10.0351 17.4228L6.95506 19.9653L6.9549 19.9654C6.73084 20.1505 6.49355 20.1266 6.29862 19.9655C6.09246 19.7952 5.95236 19.4718 6.06123 19.0907L7.23819 14.9759L7.23826 14.9756C7.3356 14.6346 7.33543 14.2689 7.23776 13.928C7.14009 13.5871 6.94701 13.2793 6.67534 13.0552C6.67527 13.0552 6.67519 13.0551 6.67511 13.0551L3.59687 10.5143C3.5968 10.5143 3.59672 10.5142 3.59665 10.5142C3.34853 10.3087 3.26709 9.96362 3.36001 9.63863C3.45306 9.31322 3.67548 9.13711 3.92497 9.13711H7.73192L7.73207 8.63711V9.13711C8.0863 9.13718 8.42371 9.00948 8.69642 8.78464C8.96797 8.56075 9.16103 8.25318 9.25877 7.91251L9.25889 7.91211L10.4359 3.79711L10.4508 3.74492ZM13.6226 8.39724C13.8103 8.55215 14.0363 8.63567 14.2683 8.63586L13.6226 8.39724Z"
                              fill="#16FF96"
                              stroke="#2C2E3A"
                            />
                          </svg>
                        </h5>
                        <p>Rating</p>
                      </div>
                      <hr />
                      <div className="text-center px-4">
                        <h5>2</h5>
                        <p className="text-nowrap">Years Lending</p>
                      </div>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
            <Col md={9} lg={8}>
              <div className="userdesc">
                <h3 className="text-capitalize">
                  <b>About Us</b>
                </h3>
                <p className="mb-lg-5 ">
                  This is the Lender’s description from the profile
                </p>
                <br />
                <hr />
                <br />
                <h4>What renters are saying about Jon</h4>

                <Slider
                  {...testimonialSlider}
                  className="mainSlider mt-3 position-relative"
                  asNavFor={nav2}
                  ref={(slider1) => setNav2(slider1)}
                >
                  <div className="testimonial-data">
                    <p>This is the last review received by the lender</p>
                    <div className="mt-lg-5 pt-lg-5 pt-0 mt-3 d-flex align-items-center">
                      <img
                        src={require("../../assets/images/DummyImg.png")}
                        className="smalluser"
                      />
                      <div>
                        <h4>Jon Smith</h4>
                        <p className="mb-0">May 2023</p>
                      </div>
                    </div>
                  </div>
                  <div className="testimonial-data">
                    <p>This is the last review received by the lender</p>
                    <div className="mt-lg-5 pt-lg-5 pt-0 mt-3 d-flex align-items-center">
                      <img
                        src={require("../../assets/images/DummyImg.png")}
                        className="smalluser"
                      />
                      <div>
                        <h4>Jon Smith</h4>
                        <p className="mb-0">May 2023</p>
                      </div>
                    </div>
                  </div>
                  <div className="testimonial-data">
                    <p>This is the last review received by the lender</p>
                    <div className="mt-lg-5  pt-lg-5 pt-0  mt-3 d-flex align-items-center">
                      <img
                        src={require("../../assets/images/DummyImg.png")}
                        className="smalluser"
                      />
                      <div>
                        <h4>Jon Smith</h4>
                        <p className="mb-0">May 2023</p>
                      </div>
                    </div>
                  </div>
                  <div className="testimonial-data">
                    <p>This is the last review received by the lender</p>
                    <div className="mt-lg-5 pt-lg-5 pt-0  mt-3 d-flex align-items-center">
                      <img
                        src={require("../../assets/images/DummyImg.png")}
                        className="smalluser"
                      />
                      <div>
                        <h4>Jon Smith</h4>
                        <p className="mb-0">May 2023</p>
                      </div>
                    </div>
                  </div>
                  <div className="testimonial-data">
                    <p>This is the last review received by the lender</p>
                    <div className="mt-lg-5 pt-lg-5 pt-0  mt-3 d-flex align-items-center">
                      <img
                        src={require("../../assets/images/DummyImg.png")}
                        className="smalluser"
                      />
                      <div>
                        <h4>Jon Smith</h4>
                        <p className="mb-0">May 2023</p>
                      </div>
                    </div>
                  </div>

                  <div className="testimonial-data">
                    <p>This is the last review received by the lender</p>
                    <div className="mt-lg-5  pt-lg-5 pt-0  mt-3 d-flex align-items-center">
                      <img
                        src={require("../../assets/images/DummyImg.png")}
                        className="smalluser"
                      />
                      <div>
                        <h4>Jon Smith</h4>
                        <p className="mb-0">May 2023</p>
                      </div>
                    </div>
                  </div>
                </Slider>

                <Row>
                  <Col md={10}>
                    <button
                      onClick={handleShow}
                      className=" w-100 d-block btn btn-outline-black mt-lg-5 mt-3"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="17"
                        height="16"
                        viewBox="0 0 17 16"
                        fill="none"
                      >
                        <path
                          d="M8.5 4L9.456 5.8515L11.5 6.1485L10 7.5L10.5 9.5L8.5 8.375L6.5 9.5L7 7.5L5.5 6.1485L7.6 5.8515L8.5 4Z"
                          fill="#1F1F1F"
                        />
                        <path
                          d="M9.368 15L8.5 14.5L10.5 11H13.5C13.6314 11.0002 13.7615 10.9745 13.8829 10.9243C14.0043 10.8741 14.1146 10.8004 14.2075 10.7075C14.3004 10.6146 14.3741 10.5043 14.4243 10.3829C14.4745 10.2615 14.5002 10.1314 14.5 10V4C14.5002 3.86862 14.4745 3.7385 14.4243 3.61708C14.3741 3.49567 14.3004 3.38535 14.2075 3.29245C14.1146 3.19956 14.0043 3.1259 13.8829 3.07572C13.7615 3.02553 13.6314 2.9998 13.5 3H3.5C3.36862 2.9998 3.2385 3.02553 3.11708 3.07572C2.99567 3.1259 2.88535 3.19956 2.79245 3.29245C2.69956 3.38535 2.6259 3.49567 2.57572 3.61708C2.52553 3.7385 2.4998 3.86862 2.5 4V10C2.4998 10.1314 2.52553 10.2615 2.57572 10.3829C2.6259 10.5043 2.69956 10.6146 2.79245 10.7075C2.88535 10.8004 2.99567 10.8741 3.11708 10.9243C3.2385 10.9745 3.36862 11.0002 3.5 11H8V12H3.5C2.96957 12 2.46086 11.7893 2.08579 11.4142C1.71071 11.0391 1.5 10.5304 1.5 10V4C1.49993 3.73734 1.55162 3.47724 1.65211 3.23456C1.75259 2.99187 1.89991 2.77137 2.08564 2.58564C2.27137 2.39991 2.49187 2.25259 2.73456 2.15211C2.97724 2.05162 3.23734 1.99993 3.5 2H13.5C13.7627 1.99993 14.0228 2.05162 14.2654 2.15211C14.5081 2.25259 14.7286 2.39991 14.9144 2.58564C15.1001 2.77137 15.2474 2.99187 15.3479 3.23456C15.4484 3.47724 15.5001 3.73734 15.5 4V10C15.5 10.5304 15.2893 11.0391 14.9142 11.4142C14.5391 11.7893 14.0304 12 13.5 12H11.0825L9.368 15Z"
                          fill="black"
                        />
                      </svg>{" "}
                      &nbsp;&nbsp;Show more reviews
                    </button>
                  </Col>
                </Row>

                <br />
                <h4>Jon’s Listings</h4>

                <Slider
                  {...listingSlider}
                  className="mainSlider mt-3 position-relative"
                  asNavFor={nav2}
                  ref={(slider2) => setNav2(slider2)}
                >
                  <div className="listing-data">
                    <div className="imglist">
                      <img src={require("../../assets/images/DummyImg.png")} />
                    </div>
                    <div className="p-3 datacard">
                      <h3>Delta Children Jordan 4-in-1 Convertible Crib</h3>
                      <a href="#">
                        <h6 className="mb-0">
                          See More Details &nbsp;{" "}
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            fill="none"
                          >
                            <path
                              d="M14 8H2M10 4L14 8L10 12"
                              stroke="#2C2E3A"
                              strokeWidth="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </h6>
                      </a>
                    </div>
                  </div>
                  <div className="listing-data">
                    <div className="imglist">
                      <img src={require("../../assets/images/DummyImg.png")} />
                    </div>
                    <div className="p-3 datacard">
                      <h3>Delta Children Jordan 4-in-1 Convertible Crib</h3>
                      <a href="#">
                        <h6 className="mb-0">
                          See More Details &nbsp;{" "}
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            fill="none"
                          >
                            <path
                              d="M14 8H2M10 4L14 8L10 12"
                              stroke="#2C2E3A"
                              strokeWidth="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </h6>
                      </a>
                    </div>
                  </div>
                  <div className="listing-data">
                    <div className="imglist">
                      <img src={require("../../assets/images/DummyImg.png")} />
                    </div>
                    <div className="p-3 datacard">
                      <h3>Delta Children Jordan 4-in-1 Convertible Crib</h3>
                      <a href="#">
                        <h6 className="mb-0">
                          See More Details &nbsp;{" "}
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            fill="none"
                          >
                            <path
                              d="M14 8H2M10 4L14 8L10 12"
                              stroke="#2C2E3A"
                              strokeWidth="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </h6>
                      </a>
                    </div>
                  </div>
                  <div className="listing-data">
                    <div className="imglist">
                      <img src={require("../../assets/images/DummyImg.png")} />
                    </div>
                    <div className="p-3 datacard">
                      <h3>Delta Children Jordan 4-in-1 Convertible Crib</h3>
                      <a href="#">
                        <h6 className="mb-0">
                          See More Details &nbsp;{" "}
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            fill="none"
                          >
                            <path
                              d="M14 8H2M10 4L14 8L10 12"
                              stroke="#2C2E3A"
                              strokeWidth="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </h6>
                      </a>
                    </div>
                  </div>
                  <div className="listing-data">
                    <div className="imglist">
                      <img src={require("../../assets/images/DummyImg.png")} />
                    </div>
                    <div className="p-3 datacard">
                      <h3>Delta Children Jordan 4-in-1 Convertible Crib</h3>
                      <a href="#">
                        <h6 className="mb-0">
                          See More Details &nbsp;{" "}
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            fill="none"
                          >
                            <path
                              d="M14 8H2M10 4L14 8L10 12"
                              stroke="#2C2E3A"
                              strokeWidth="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </h6>
                      </a>
                    </div>
                  </div>
                </Slider>
              </div>
            </Col>
          </Row>
        </Container>
      </div>

      <Modal
        show={show}
        onHide={handleClose}
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Body className="">
          <div className="header-area pt-0">
            <h4 className="text-black mb-4">120 Reviews</h4>
            <div className="testimonial-data autoscroll">
              <div className=" px-3">
                <div className="d-flex align-items-center">
                  <img
                    src="/static/media/DummyImg.2fda6558cd58b877e14f.png"
                    className="smalluser"
                  />
                  <div>
                    <h4>Jon Smith</h4>
                    <p className="mb-0">May 2023</p>
                  </div>
                </div>
                <p>
                  This is the last review received by the lender text text ytext
                </p>
              </div>
              <hr />
              <div className=" px-3">
                <div className="d-flex align-items-center">
                  <img
                    src="/static/media/DummyImg.2fda6558cd58b877e14f.png"
                    className="smalluser"
                  />
                  <div>
                    <h4>Jon Smith</h4>
                    <p className="mb-0">May 2023</p>
                  </div>
                </div>
                <p>
                  This is the last review received by the lender text text ytext
                </p>
              </div>
              <hr />
              <div className="px-4">
                <div className="d-flex align-items-center">
                  <img
                    src="/static/media/DummyImg.2fda6558cd58b877e14f.png"
                    className="smalluser"
                  />
                  <div>
                    <h4>Jon Smith</h4>
                    <p className="mb-0">May 2023</p>
                  </div>
                </div>
                <p>
                  This is the last review received by the lender text text ytext
                </p>
              </div>
            </div>
            <button
              onClick={handleShow}
              className=" w-100 d-block btn btn-outline-black mt-lg-5 mt-3"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="17"
                height="16"
                viewBox="0 0 17 16"
                fill="none"
              >
                <path
                  d="M8.5 4L9.456 5.8515L11.5 6.1485L10 7.5L10.5 9.5L8.5 8.375L6.5 9.5L7 7.5L5.5 6.1485L7.6 5.8515L8.5 4Z"
                  fill="#1F1F1F"
                />
                <path
                  d="M9.368 15L8.5 14.5L10.5 11H13.5C13.6314 11.0002 13.7615 10.9745 13.8829 10.9243C14.0043 10.8741 14.1146 10.8004 14.2075 10.7075C14.3004 10.6146 14.3741 10.5043 14.4243 10.3829C14.4745 10.2615 14.5002 10.1314 14.5 10V4C14.5002 3.86862 14.4745 3.7385 14.4243 3.61708C14.3741 3.49567 14.3004 3.38535 14.2075 3.29245C14.1146 3.19956 14.0043 3.1259 13.8829 3.07572C13.7615 3.02553 13.6314 2.9998 13.5 3H3.5C3.36862 2.9998 3.2385 3.02553 3.11708 3.07572C2.99567 3.1259 2.88535 3.19956 2.79245 3.29245C2.69956 3.38535 2.6259 3.49567 2.57572 3.61708C2.52553 3.7385 2.4998 3.86862 2.5 4V10C2.4998 10.1314 2.52553 10.2615 2.57572 10.3829C2.6259 10.5043 2.69956 10.6146 2.79245 10.7075C2.88535 10.8004 2.99567 10.8741 3.11708 10.9243C3.2385 10.9745 3.36862 11.0002 3.5 11H8V12H3.5C2.96957 12 2.46086 11.7893 2.08579 11.4142C1.71071 11.0391 1.5 10.5304 1.5 10V4C1.49993 3.73734 1.55162 3.47724 1.65211 3.23456C1.75259 2.99187 1.89991 2.77137 2.08564 2.58564C2.27137 2.39991 2.49187 2.25259 2.73456 2.15211C2.97724 2.05162 3.23734 1.99993 3.5 2H13.5C13.7627 1.99993 14.0228 2.05162 14.2654 2.15211C14.5081 2.25259 14.7286 2.39991 14.9144 2.58564C15.1001 2.77137 15.2474 2.99187 15.3479 3.23456C15.4484 3.47724 15.5001 3.73734 15.5 4V10C15.5 10.5304 15.2893 11.0391 14.9142 11.4142C14.5391 11.7893 14.0304 12 13.5 12H11.0825L9.368 15Z"
                  fill="black"
                />
              </svg>{" "}
              &nbsp;&nbsp;Show more reviews
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};
export default About;
